import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

class Field extends React.Component {
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            this.props.autoScrollToError &&
            nextProps.error &&
            nextProps.error !== this.props.error
        ) {
            // FIXME: don't use findDOMNode, see https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md
            ReactDOM.findDOMNode(this).scrollIntoView(); // eslint-disable-line react/no-find-dom-node
        }
    }

    render() {
        var classes = classNames({
            field: true,
            'field--standalone': this.props.standAlone,
            'field--submission': this.props.submission,
            'field--checkable': this.props.checkable,
            'field--cancellable-submission': this.props.cancellableSubmission,
            'field--checkable-set': this.props.checkableSet,
        });

        var data = {};
        if (this.props.error) {
            data['data-field-error'] = true;
        }

        return (
            <div className={classes} {...data}>
                {this.props.children}
            </div>
        );
    }
}

Field.propTypes = {
    children: PropTypes.node.isRequired,
    error: PropTypes.bool,
    autoScrollToError: PropTypes.bool,
    submission: PropTypes.bool,
    cancellableSubmission: PropTypes.bool,
    standAlone: PropTypes.bool,
    checkable: PropTypes.bool,
    checkableSet: PropTypes.bool,
};

export class FieldTitle extends React.Component {
    render() {
        return (
            <label className="field__title" htmlFor={this.props.htmlFor}>
                {this.props.children}
            </label>
        );
    }
}

FieldTitle.defaultProps = {
    htmlFor: null,
};

FieldTitle.propTypes = {
    children: PropTypes.node.isRequired,
    htmlFor: PropTypes.string,
};

export class FieldInput extends React.Component {
    render() {
        var classes = classNames({
            field__input: true,
            'field__input--submit': this.props.isSubmit,
            'field__input--cancel': this.props.isCancel,
        });

        return <div className={classes}>{this.props.children}</div>;
    }
}

FieldInput.defaultProps = {
    isSubmit: false,
    isCancel: false,
};

FieldInput.propTypes = {
    children: PropTypes.node.isRequired,
    isSubmit: PropTypes.bool,
    isCancel: PropTypes.bool,
};

export class FieldValidationMessage extends React.Component {
    render() {
        return (
            <div className="field__validation">
                <div className="field__validation__message">{this.props.children}</div>
            </div>
        );
    }
}

FieldValidationMessage.propTypes = {
    children: PropTypes.node.isRequired,
};

export class FieldChildren extends React.Component {
    render() {
        return <div className="field__children">{this.props.children}</div>;
    }
}

FieldChildren.propTypes = {
    children: PropTypes.node,
};

export class FieldMessage extends React.Component {
    render() {
        return <div className="field__message">{this.props.children}</div>;
    }
}

FieldMessage.propTypes = {
    children: PropTypes.node.isRequired,
};

export class FlagField extends React.Component {
    render() {
        return (
            <div className="field field--flag">
                <div className="field--flag__pole">
                    <div className="field__input">{this.props.input}</div>
                </div>
                <div className="field--flag__flag">{this.props.label}</div>
            </div>
        );
    }
}

FlagField.defaultProps = {
    input: null,
    label: null,
};

FlagField.propTypes = {
    input: PropTypes.element,
    label: PropTypes.element,
};

export default Field;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/field.jsx